import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { CapabilitiesStore } from '@core/stores';
import { TimeFrame } from '@core/domain/entities';
import { NotifyService } from '@core/shared/services';
import { FiltersProvider } from '@data/providers';

export const timeFramesResolver: ResolveFn<TimeFrame[]> = async () => {
  const store = inject(CapabilitiesStore);
  const notify = inject(NotifyService);
  const filterProvider = inject(FiltersProvider);

  const resp = await store.getTimeFrames();

  if (resp.isOk === false) {
    notify.warnByCode(resp.error.code, 'Ups!');
    return [];
  }

  filterProvider.setTimeFrames(resp.data);

  return resp.data;
};
